export function kwToPs(kw: number): number {
    return Math.floor(kw * 1.359_62);
}
